export class AppUrl {
  host: string = "https://admapp.loga.net.br";
  host_minha_loga: string = "https://minhaloga.loga.net.br/#";
  minha_loga_version: number = 4.0;
}



// WEBPACK FOOTER //
// /Users/gmdimitriz/Projects/minha-loga/src/app/app-url.ts